{
  "gtm": {
    "google-analytics": "analytics",
    "google-ads": "ads",
    "google-tag-manager": "necessary",
    "meta-pixel-for-wordpress": "ads",
    "facebook-pixel": "ads",
    "facebook": "ads",
    "microsoft-ads": "ads",
    "linkedin-insight": "ads"
  },
  "embeds": {
    "maps": "functional",
    "google-maps": "functional",
    "youtube": "functional",
    "vimeo": "functional",
    "instagram": "functional",
    "google-fonts": "necessary",
    "recaptcha": "functional"
  },
  "presets": {
    "google-consent-mode": "necessary",
    "google-analytics-4": "analytics",
    "google-analytics-event-tracking": "analytics",
    "google-ads-conversion": "ads",
    "google-ads-conversion-tracking": "ads",
    "google-enhanced-conversions": "ads",
    "meta-pixel": "ads",
    "meta-pixel-advanced-matching": "ads",
    "meta-social-plugins": "functional",
    "linkedin-analytics": "analytics",
    "linkedin-ads": "ads",
    "linkedin-insight-tag": "ads",
    "linkedin-conversions-api": "ads",
    "openai-ads": "ads"
  }
}
